/*
 * Bezier Function
 * Get X,Y by t
 * Refer to https://pomax.github.io/bezierinfo/
 * @params a,b,c,d {x:x,y:y}
 * @params t is between 0-1
 * @return {{x:x on curve ,y:y on curve}}
 */
function Bezier(a, b, c, d, t) {
  var point = { x: 0, y: 0 },
    mt = 1 - t,
    mt2 = mt * mt,
    mt3 = mt2 * mt;

  //fx(t) = x1 * (1-t)³ + x2 * 3 * (1-t)²t + x3 * 3 * (1-t)t² + x4 * t³
  point.x =
    a.x * mt3 + b.x * 3 * mt2 * t + c.x * 3 * mt * t * t + d.x * t * t * t;

  //fy(t) = y1 * (1-t)³ + y2 * 3 * (1-t)²t + y3 * 3 * (1-t)t² + y4 * t³
  point.y =
    a.y * mt3 + b.y * 3 * mt2 * t + c.y * 3 * mt * t * t + d.y * t * t * t;

  return point;
}
export default Bezier;
